// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__9MLUH","secondary":"Button_secondary__sUGsj","small":"Button_small__jToKs"};